
import utils from 'services/utils';


const result = {
    'captchaPopup__textInput': null,
    'captchaPopup__submitButton': null,

    'withdrawForm__paySysButton': null,
    'withdrawForm__${name}PaySysButton': null,
    'withdrawForm__detailsInput': null,
    'withdrawForm__${name}DetailsInput': null,
    'depositForm__detailsInput': null,
    'depositForm__${name}DetailsInput': null,
    'withdrawForm__amountInput': null,
    'withdrawForm__submitButton': null,

    'createGiftCardFrom__amountInput': null,
    'createGiftCardFrom__submitButton': null,
    'createGiftCardFrom__showButton': null,

    'activateGiftCardFrom__giftCardCodeInput': null,
    'activateGiftCardFrom__submitButton': null,
    
    'supportForm__textInput': null,
    'supportForm__submitButton': null,

    'depositForm__paySysButton': null,
    'depositForm__${name}PaySysButton': null,
    'depositForm__amountInput': null,
    'depositForm__phoneInput': null,
    'depositForm__submitButton': null,

    'sendCoinForm__outDataInput': null,
    'sendCoinForm__outSumInput': null,
    'sendCoinForm__currencyInput': null,
    'sendCoinForm__submitButton': null,
    'sendCoinForm__highPriorityInput': null,

    'exchangeForm__switchButton': null,
    'exchangeForm__sourceAmountInput': null,
    'exchangeForm__targetAmountInput': null,
    'exchangeForm__sourceCurrencySelect': null,
    'exchangeForm__targetCurrencySelect': null,
    'exchangeForm__submitButton': null,
    'exchangeForm__phoneInput': null,

    'changePhoneForm__phoneInput': null,
    'changePhoneForm__submitButton': null,
};

const getReplacerMethod = (key) => {
    return (data) => {
        let result = key;
        Object.keys(data).forEach((dataKey) => {
            result = result.replace('${' + dataKey + '}', utils.translite(data[dataKey]))
        });
        return 'js-' + result;
    };
};

Object.keys(result)
    .forEach((key) => {
        if (~key.indexOf('$')) {
            result[key] = getReplacerMethod(key);
        } else {
            result[key] = 'js-' + key;
        }
    });

module.exports = result;
